<template>
  <div class="container">
    <div class="oferta-container padding-17-left-right">
      <wrap-container class="w100 grid-container grid-container--6-6">
        <wrap-container class="col1 main-title">
          <p id="titulo" class="titulo p28 oscuro hola">
            ¡Hola <span data-obfuscate>{{ nombre }}</span
            >!
          </p>
          <p id="subtitulo" class="titulo p32 oscuro medium tenemos">
            Tenemos estos beneficios para vos
          </p>
        </wrap-container>
      </wrap-container>
      <wrap-container class="cascade w50">
        <div class="oferta">
          <div class="card-container">
            <product-image-container
              class="card"
              :tarjetas="['visa-debito-nacional']"
              quantumObfuscate
            />
          </div>
          <p
            class="caja-de-ahorro"
            v-safe-html="config.pasos.ofertaCuenta.titulo"
          />
          <p
            class="subtitulo_cuenta"
            v-safe-html="config.pasos.ofertaCuenta.subtitulo"
          />
          <premios-oferta-caja-ahorro />
          <sales-button
            class="sales-button"
            ref="salesbutton"
            :label="config.pasos.ofertaCuenta.botonSiguiente"
            @click.native="continuar"
          />
          <div class="qr-container">
            <div data-obfuscate>
              <openmarket-QR
                class="qr-code"
                :scale="15"
                errorCorrectionLevel="L"
                :url="getURLQR()"
              />
            </div>
            <div class="sms-container">
              <p class="sms_send">
                Continua el proceso desde tu celular escaneando el codigo QR o
                mediante SMS
              </p>
              <custom-send-sms-link
                label="Recibir SMS"
                @click.native="openModalSMS"
              />
            </div>
          </div>
        </div>
      </wrap-container>

      <wrap-container class="cascade w50 margin-benefits-m">
        <offer-group
          class="content-bonus-items margin-bonus-m"
          label="¿Qué incluye tu oferta?"
        >
          <offer-element
            v-for="inc in esCuenta.oferta"
            v-bind:key="inc.label"
            :label="inc.label"
            :description="inc.description"
            :linktitle="inc.linktitle"
            :linkpath="inc.linkpath"
          />
        </offer-group>
        <offer-group
          class="content-bonus-items margin-bonus-m"
          label="Y te damos estos beneficios:"
        >
          <offer-element
            v-for="inc in ofertaCajaAhorro.beneficios"
            v-bind:key="inc.label"
            :label="inc.label"
            :description="inc.description"
            :linktitle="inc.linktitle"
            :linkpath="inc.linkpath"
          />
        </offer-group>
        <modal-sms
          :show="showModal"
          @close="showModal = false"
          @sendSMS="sendSMS"
          :buttonLabel="buttonLabel"
          :mensaje="mensajeCuenta"
          quantumObfuscate
        />
      </wrap-container>
      <!-- ESTE button-mobile NO SE VE EN MOBILE NI EN DESKTOP -->
      <div class="button-mobile">
        <sales-button
          class="sales-button"
          ref="salesbutton"
          :label="config.pasos.ofertaCuenta.botonSiguiente"
          @click.native="continuar"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import WrapContainer from "@/components/core/Container";
import OfferGroup from "@/components/core/OfferGroup";
import OfferElement from "@/components/core/OfferElement";
import ModalSms from "@/components/core/modals/ModalSms";
import SalesButton from "@/components/core/SalesButton";
import PremiosOfertaCajaAhorro from "@/components/core/custom/PremiosOfertaCajaAhorro";
import ofertaCA from "@/config/constants/ofertaCA";
import ofertaCGU from "@/config/constants/ofertaCGU";
import ProductImageContainer from "@/components/core/ProductImageContainer";
import CustomSendSmsLink from "@/components/core/CustomSendSmsLink";
import OpenmarketQR from "../components/core/OpenmarketQR.vue";
import offerPage from "@/mixins/offer-page";
import bus from "../bus/index.js";

export default {
  name: "OfertaCuenta",
  mixins: [offerPage],
  components: {
    WrapContainer,
    OfferGroup,
    OfferElement,
    ModalSms,
    SalesButton,
    PremiosOfertaCajaAhorro,
    ProductImageContainer,
    CustomSendSmsLink,
    OpenmarketQR
  },
  data() {
    return {
      showModal: false,
      buttonLabel: "Enviar SMS"
    };
  },
  methods: {
    continuar() {
      bus.$emit("analytics:event", {
        event: "interaction_link",
        eventData: {
          name: "abri tu cuenta en BBVA",
          level2: "oferta",
          level3: "ca"
        }
      });
      this.$router.push(this.config.pasos.ofertaCuenta.pasoSiguiente);
    }
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    ofertaCajaAhorro() {
      return ofertaCA();
    },
    ofertaCGU() {
      return ofertaCGU();
    },
    esCuenta() {
      Vue.$log.info("esCuenta", _BBVA_MOTOR);
      let cuenta;
      if (_BBVA_MOTOR === "ofertaCGU") {
        cuenta = ofertaCGU();
      } else if (
        _BBVA_MOTOR === "ofertaCajaAhorro" ||
        _BBVA_MOTOR === "ofertaNomina"
      ) {
        cuenta = ofertaCA();
      }
      return cuenta;
    },
    mensajeCuenta() {
      let mensaje;
      if (_BBVA_MOTOR === "ofertaCGU") {
        mensaje =
          "Obten&#233; tu Cuenta gratuita universal ahora ingresando a ";
      } else if (
        _BBVA_MOTOR === "ofertaCajaAhorro" ||
        _BBVA_MOTOR === "ofertaNomina"
      ) {
        mensaje = "Obten&#233; tu Caja de ahorro ahora ingresando a ";
      }
      return mensaje;
    }
  }
};
</script>
<style scoped>
.content-bonus-items {
  margin-left: 17px;
}

.bonus-items {
  margin-top: 50px;
  padding-bottom: 20px;
}

div.container {
  height: 100%;
}

div.container .sales-button {
  display: none;
}

.oferta-container {
  max-width: 1200px;
  margin: 0 auto;
}

div.oferta {
  display: block;
  max-width: 550px;
  margin-bottom: 40px;
}

p {
  margin-top: 0px;
  margin-bottom: 0px;
}

p#subtitulo {
  margin-bottom: 37px;
}

.main-title {
  margin-bottom: -20px;
}

.caja-de-ahorro {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 26px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #666666;
  margin-top: 40px;
  margin-bottom: 16px;
}

.subtitulo_cuenta {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #666666;
  margin-bottom: 50px;
}

.middle-iwt {
  margin-left: 62px;
  margin-right: 62px;
}

.button-mobile {
  display: none;
}

.que-incluye {
  margin-bottom: 16px;
  margin-top: 0px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  margin-left: 17px;
}

.sales-button {
  display: none;
}

.qr-container {
  display: grid;
  grid-template-columns: 230px 240px;
  grid-gap: 5px;
}

.sms-container {
  margin-top: 5px;
  grid-column: 2;
  align-self: top;
}

.sms_send {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 10%;
}

@media screen and (max-width: 599px) {
  #titulo {
    font-size: 20px;
  }

  #subtitulo {
    font-size: 26px;
  }

  .hola {
    text-align: center;
  }

  .tenemos {
    text-align: center;
    margin-top: 10px;
  }

  .caja-de-ahorro {
    text-align: center;
    line-height: 1.2;
    font-size: 20px;
    margin-top: 30px;
  }

  .subtitulo_cuenta {
    text-align: center;
    font-size: 15px;
    margin-bottom: 40px;
  }

  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }

  .card-container {
    margin: 0 auto;
    text-align: center;
  }

  .card {
    min-width: 149px;
    min-height: 94px;
  }

  .margin-benefits-m {
    margin-top: 32px;
  }

  .button-mobile {
    display: block;
    margin-bottom: 60px;
    margin-top: -25px;
  }

  div.container .sales-button {
    display: inline-block;
  }

  .qr-container {
    display: none;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .card-container {
    margin: 0 auto;
    text-align: center;
  }

  .hola {
    width: 200%;
    text-align: center;
  }

  .tenemos {
    width: 200%;
    text-align: center;
  }

  .caja-de-ahorro {
    text-align: center;
  }

  .subtitulo_cuenta {
    text-align: center;
  }

  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
